import { render, staticRenderFns } from "./handleHistroyInfo.vue?vue&type=template&id=58f6341e&scoped=true"
import script from "./handleHistroyInfo.vue?vue&type=script&lang=js"
export * from "./handleHistroyInfo.vue?vue&type=script&lang=js"
import style0 from "./handleHistroyInfo.vue?vue&type=style&index=0&id=58f6341e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6341e",
  null
  
)

export default component.exports